<div ngFlex="row" fxLayoutAlign="center center">
  <h1 class="mat-title">User journey on StudentHub on {{sessionStartDate}}</h1>
</div >

<div class="control-row" ngFlex="row" fxLayoutAlign="center center">
  <button mat-raised-button (click)="goBack()">Go back</button>
  <mat-button-toggle-group appearance="legacy" name="selection" (change)="onFilterChange($event)" [(value)]="filterSelection">
    <mat-button-toggle value="all">Show All</mat-button-toggle>
    <mat-button-toggle value="errors">Show Errors</mat-button-toggle>
   
  </mat-button-toggle-group>
</div>

<table style="width: 100%;" mat-table [dataSource]="logModels" class="mat-elevation-z8 full-width">


  <ng-container matColumnDef="timestamp">
    <th mat-header-cell *matHeaderCellDef> Timeline </th>
    <td mat-cell *matCellDef="let log"> {{getDuration(log.timestamp)}} </td>
  </ng-container>


  <ng-container matColumnDef="page">
    <th mat-header-cell *matHeaderCellDef> Page </th>
    <td mat-cell *matCellDef="let log"> {{log.pageId}} </td>
  </ng-container>

  <ng-container matColumnDef="eventType">
    <th mat-header-cell *matHeaderCellDef> Event Type </th>
    <td mat-cell *matCellDef="let log"> {{log.eventType}} </td>
  </ng-container>

  <ng-container matColumnDef="stepDescription">
    <th mat-header-cell *matHeaderCellDef> Event description </th>
    <td mat-cell *matCellDef="let log"> {{log.payload}}</td>
  </ng-container>

  <ng-container matColumnDef="context">
    <th mat-header-cell *matHeaderCellDef> Context </th>
    <td mat-cell *matCellDef="let log"> {{log.context}} </td>
  </ng-container>

  <ng-container matColumnDef="help">
    <th mat-header-cell *matHeaderCellDef> Help </th>
    <td mat-cell *matCellDef="let log"> {{log.help}}</td>
  </ng-container>



  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>